<template>
  <div class="Yodapp">
    <div class="container mb-5" id="nav">
      <b-navbar>
        <template slot="brand">
          <b-navbar-item tag="router-link" :to="{ path: '/' }">
            <img alt="Yodapp" src="../assets/logo.svg" />
          </b-navbar-item>
        </template>
        <template slot="end">
          <b-navbar-item href="#">
            Que a Força (qualidade) esteja com você!
          </b-navbar-item>
          <b-navbar-item tag="div">
            <div class="buttons">
              <a href="/" class="button is-success"><strong>Voltar</strong></a>
            </div>
          </b-navbar-item>
        </template>
      </b-navbar>
    </div>

    <div class="container">
      <section>
        <div class="card" aria-id="contentIdForA11y3">
          <div
            class="card-header"
            role="button"
            aria-controls="contentIdForA11y3"
          >
            <p class="card-header-title">
              <template>Cadastrar novo usuário</template>
            </p>
          </div>
          <div class="card-content">
            <div class="content">
              <form>
                <b-field
                  grouped
                  group-multiline
                  position="is-left"
                  class="mb-5"
                >
                  <b-field  label="Nome completo"
                    expanded
                    :type="alertNome.type"
                    :message="alertNome.message"
                  >
                    <b-input
                      id="nome"
                      name="nome"
                      v-model="usuario.nome"
                      placeholder="Han Solo"
                      expanded
                      type="text"
                      icon="account"
                    >
                    </b-input>
                  </b-field>

                  <b-field  label="Email"
                    expanded
                    :type="alertEmail.type"
                    :message="alertEmail.message"
                  >
                    <b-input
                      id="email"
                      name="email"
                      v-model="usuario.email"
                      placeholder="han.solo@starwars.com"
                      type="text"
                      icon="email"
                    >
                    </b-input>
                  </b-field>

                  <b-field  label="Ordem"
                    expanded
                    :type="alertOrdem.type"
                    :message="alertOrdem.message"
                  >
                    <b-select
                      class="ordem"
                      placeholder="Selecione..."
                      expanded
                      v-model="usuario.ordem"
                      icon="view-dashboard"
                    >
                      <option value="1">Jedi</option>
                      <option value="2">Sith</option>
                      <option value="3">Outros</option>
                    </b-select>
                  </b-field>
                </b-field>

                <b-field class="block tipo-jedi" v-if="usuario.ordem == 1">
                  <b-radio
                    v-model="usuario.tipoJedi"
                    name="tipo-jedi"
                    native-value="Cavaleiro Jedi"
                  >
                    Cavaleiro Jedi
                  </b-radio>
                  <b-radio
                    v-model="usuario.tipoJedi"
                    name="tipo-jedi"
                    native-value="Padawan"
                  >
                    Padawan
                  </b-radio>
                </b-field>

                <b-field grouped group-multiline position="is-left">
                  <b-field label="Data de nascimento"
                    expanded
                    :type="alertNiver.type"
                    :message="alertNiver.message"
                  >
                    <b-datepicker 
                      v-model="usuario.niver"
                      :locale="locale"
                      name="Data de nascimento"
                      placeholder="Selecione..."
                      icon="calendar-today"
                      :icon-right="usuario.niver ? 'close-circle' : ''"
                      icon-right-clickable
                      @icon-right-click="clearDate"
                      trap-focus
                    >
                    </b-datepicker>
                  </b-field>

                  <b-field label="Instagram"
                    expanded
                    :type="alertInsta.type"
                    :message="alertInsta.message"
                  >
                    <b-input
                      id="insta"
                      name="instagram"
                      v-model="usuario.instagram"
                      placeholder="@hansolo"
                      type="text"
                      icon="instagram"
                    >
                    </b-input>
                  </b-field>
                </b-field>

                <b-field class="comunications mt-5">
                  <b-checkbox
                    name="comunications"
                    v-model="usuario.comunicacoes"
                    >Aceito receber comunicações estelares.</b-checkbox
                  >
                </b-field>

                <button
                  type="button"
                  class="button is-primary has-text-white"
                  @click="cadastrar()"
                >
                  Cadastrar
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      locale: "pt-BR",
      alertNome: {
        message: "",
        type: "",
      },
      alertEmail: {
        message: "",
        type: "",
      },
      alertOrdem: {
        message: "",
        type: "",
      },
      alertNiver: {
        message: "",
        type: "",
      },
      alertInsta: {
        message: "",
        type: "",
      },
      usuario: {
        nome: "",
        email: "",
        ordem: null,
        niver: null,
        instagram: "",
        tipoJedi: "",
        comunicacoes: false,
      },
    };
  },
  methods: {
    clearDate() {
      this.usuario.niver = null;
    },
    async cadastrar() {
      let usuarios = JSON.parse(localStorage.getItem("usuarios"));

      const { usuario } = this;

      console.log(usuario);

      this.alertMessage = "";

      this.alertNome = {
        message: "",
        type: "",
      };
      this.alertEmail = {
        message: "",
        type: "",
      };
      this.alertOrdem = {
        message: "",
        type: "",
      };
      this.alertNiver = {
        message: "",
        type: "",
      };
      this.alertInsta = {
        message: "",
        type: "",
      };

      if (!usuario.nome) {
        this.alertNome.message = "O nome é obrigatório.";
        this.alertNome.type = "is-danger";
      }

      if (!usuario.email) {
        this.alertEmail.message = "O email é obrigatório.";
        this.alertEmail.type = "is-danger";
      }

      if (!usuario.ordem) {
        this.alertOrdem.message = "Escolha a ordem.";
        this.alertOrdem.type = "is-danger";
      }

      if (!usuario.niver) {
        this.alertNiver.message = "Informe a data de nascimento.";
        this.alertNiver.type = "is-danger";
      }

      if (!usuario.instagram) {
        this.alertInsta.message = "O instagram é obrigatório.";
        this.alertInsta.type = "is-danger";
      }

      if (
        usuario.nome &&
        usuario.email &&
        usuario.ordem &&
        usuario.niver &&
        usuario.instagram
      ) {
        const re =
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(usuario.email)) {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Oops! O email é incorreto.",
            type: "is-danger",
          });

          return null;
        }

        if (!usuario.tipoJedi && usuario.ordem == 1) {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Informe se o usuário é um cavaleiro Jedi ou Padawan ;)",
            type: "is-danger",
          });

          return null;
        }

        this.usuario.id = this.$faker().phone.phoneNumberFormat();

        usuarios.push(this.usuario);

        localStorage.setItem("usuarios", JSON.stringify(usuarios));

        this.$buefy.toast.open({
          duration: 5000,
          message: "Usuário cadastrado com sucesso!",
          type: "is-success",
        });

        this.usuario = {
          nome: "",
          ordem: null,
          email: "",
          niver: null,
          instagram: "",
          tipoJedi: "",
          comunicacoes: false,
        };
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
article[class*="message"] {
  max-width: 500px;
}

.tipo-jedi,
.comunications {
  margin-left: 5px;
}
</style>
